import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import "../../CSS/Grid.css"

class PopUp extends Component{
    handleSaveDetails=()=>{
        this.props.handleSaveDetails()
    }


    render() {
        return(
            <div>
                <div className='pop-up-container'>
                    <div className='pop-up-message'>
                        <div className="Add_Border_For_Separations" >
                            <img src={process.env.PUBLIC_URL+"/logo-light.png"} alt="Company Logo" className="company-logo" />
                            <button className="close-button" onClick={()=>this.handleSaveDetails()}>X</button>
                        </div>
                        <h2>{this.props.MessageType}!</h2>
                        <p>{this.props.MessageDescription}.</p>
                        <button className="ok-button" onClick={()=>this.handleSaveDetails()}>OK</button>
                    </div>
                </div>
            </div>
        )
    }

}


const mapStateToProps=(state)=>{
    return{
        originPortJSON:state.route.originPortJSON.Ports
    }
}

export default connect(mapStateToProps, actions)(PopUp);
